import {
  Table as MuiTable,
  TableBody,
  TableRow,
  TableHead,
} from '@material-ui/core';
import t from 'prop-types';
import React, {Fragment} from 'react';
import ReactTable, {ReactTableDefaults} from 'react-table';
import {omit} from 'ramda';
import 'react-table/react-table.css';
import styled from 'styled-components';
import AmpTableCell from '../atoms/TableCell';
import AmpTh from '../atoms/Th';
import AmpTableRow from '../atoms/TableRow';
import Empty from '../molecules/Empty';

export const defaultTrProps = {isRow: true};

export const Tr = ({isRow, ...rest}) =>
  !isRow ? (
    <TableRow {...rest} />
  ) : (
    <AmpTableRow {...rest} classes={{selected: 'selected'}} />
  );

Tr.propTypes = {
  isRow: t.bool,
};

const Th = ({sortable, ...rest}) => <AmpTh sortable={sortable} {...rest} />;

Th.propTypes = {
  sortable: t.bool,
};

const Td = ({style, ...props}) => (
  <AmpTableCell style={omit(['flex'], style)} {...props} />
);

Td.propTypes = {
  style: t.object,
};

Object.assign(ReactTableDefaults, {
  showPagination: false,
  minRows: 0,
  defaultPageSize: 1000,
  getNoDataProps: ({loading}) => ({loading}),
  NoDataComponent: Empty,
  resizable: false,
  TableComponent: styled(MuiTable)`
    border-collapse: separate;
    @supports (-ms-ime-align:auto) {
      border-collapse: collapse;
    }
    border-spacing: 0px 10px;
  `,
  TbodyComponent: TableBody,
  TheadComponent: TableHead,
  ThComponent: Th,
  // Maybe required for grouping rows, but currently breaks rendering
  TrGroupComponent: Fragment,
  TrComponent: Tr,
  getTrProps: () => defaultTrProps,
  TdComponent: Td,
});

// https://github.com/tannerlinsley/react-table/issues/1501
/* eslint-disable react/forbid-foreign-prop-types */
ReactTable.propTypes.TableComponent = t.elementType;
ReactTable.propTypes.TheadComponent = t.elementType;
ReactTable.propTypes.TbodyComponent = t.elementType;
ReactTable.propTypes.TrGroupComponent = t.elementType;
/* eslint-enable react/forbid-foreign-prop-types */

const Table = styled(ReactTable)`
  border: none !important;
`;

export default Table;
